import { IIdTextId } from '../../shared/fi-shared-interfaces';
import { FiLoginReminderTimePeriodType } from './fi-login-reminder-enums';

export const FiLoginReminderTimePeriodTypes: IIdTextId[] = [
    {
        id: FiLoginReminderTimePeriodType.Days,
        textId: 'common.days',
    },
    {
        id: FiLoginReminderTimePeriodType.Weeks,
        textId: 'common.weeks',
    },
    {
        id: FiLoginReminderTimePeriodType.Months,
        textId: 'common.months',
    },
];
